import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QuizSession } from '~/monolith-api';
import { saveSurveyJsQuizSession } from '~/pages/api/quizzes';
import { getQuizKey } from '~/pages/Quizzes/_shared/useQuiz';

type SaveQuizSessionRequest = {
   quizid: number;
   response_json: string;
   quiz_revisionid: number;
   langid: string;
};

export function saveQuizSessionKey() {
   return ['save-quiz-session'];
}

export function useSaveQuizSession() {
   const queryClient = useQueryClient();

   const mutationFunction = async ({
      quizid,
      response_json,
      quiz_revisionid,
      langid,
   }: SaveQuizSessionRequest): Promise<QuizSession> => {
      const result = await saveSurveyJsQuizSession(quizid, response_json, quiz_revisionid, langid);
      queryClient.invalidateQueries({
         queryKey: getQuizKey(quizid),
      });

      return result;
   };

   return useMutation({
      mutationFn: mutationFunction,
      mutationKey: saveQuizSessionKey(),
   });
}
